import React from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import monitor from '../../../service/bigquery';
import { useOnceBeforeRender } from '../../../shared/hooks';
import { type TrackingData } from '../../../shared/lib/getTrackingData';
import DiscoverLogoIdeas from '../../components/DiscoverLogoIdeas/DiscoverLogoIdeas';

const { store: mixpanelStore } = makersExperience.discoverLogoIdeas;

interface ClientDiscoverLogoIdeasPageProps {
  tracking: TrackingData;
}

export default function ClientDiscoverLogoIdeasPage({ tracking }: ClientDiscoverLogoIdeasPageProps) {
  useOnceBeforeRender(() => {
    monitor.initialize(tracking);
    mixpanelStore.pageType.setData('Hub');
  });

  return <DiscoverLogoIdeas refCtxId={tracking.refCtxId} />;
}
